import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledDDContent = styled(FlexRow)`
    justify-content: flex-start;
    width: 100%;
`;

export const StyledContainerWithChips = styled(FlexColumn)<{ hasChips?: boolean }>`
    margin-top: ${({ hasChips }) => (!hasChips ? ` 60px` : "12px")};
    width: 100%;
`;

export const StyledTabbedDropdownWrapper = styled.div`
    display: flex;
    width: 100%;

    .technology-category-dd {
        display: flex;
        width: 100%;
    }
`;

export const StyledDropdownButtonContainer = styled.div`
    display: flex;
    & .DropdownButton {
        & .DropdownButton--triangle {
            color: ${colorsPalettes.carbon["400"]};
        }
    }
`;
